import './CatalogSelect.css'
import {NavigationFooterProps} from "../Navigation/NavigationFooter";
import {CatalogCategory} from "./Catalog";
import {useTranslation} from "react-i18next";

export type CatalogSelectProps = {
    navigationFooterProps: NavigationFooterProps
    categories: CatalogCategory[] // All already included
    includeAll: boolean
}

export function CatalogSelect(props : CatalogSelectProps){
    const curr = props.navigationFooterProps.selected;
    const {t} = useTranslation()

    const getClass = (position : number) => {
        if (position === curr) return "catalog-select-button catalog-select-button-selected";
        else return "catalog-select-button";
    }

    const selectItem = (position : number) => () => props.navigationFooterProps.setSelected(position);

    if (props.includeAll) {
        return <div className="catalog-select-buttons">
            <button className={getClass(0)} onClick={selectItem(0)}> {t("____catalogSelectionAll")} </button>
            {props.categories.map((entry, index) => {
                return <button className={getClass(index + 1)} onClick={selectItem(index + 1)}
                               key={index}> {entry.text} </button>
            })}
        </div>
    }

    return <div className="catalog-select-buttons">
        {props.categories.map((entry, index) =>
            <button className={getClass(index)} onClick={selectItem(index)} key={index}> {entry.text} </button>
        )}
    </div>
}